module.exports = __webpack_public_path__ + "media/images/pic/certificates/dobra-firma-848c6196fcde2d05e9bd8d3390866117.png";